export default function FontSize (pButton)
{
  this.createFontSizeDropdownButton = () =>
  {
    const invalidCharacters = /[^0123456789]/g;

    let prevValue = 0,
        validateValueTM = null,
        checkValueTM = null;

    pButton.pAttribute.eButtonText = {};
    pButton.pAttribute.eButtonText.blur = onBlur;
    pButton.pAttribute.eButtonText.isFocus = false;
    pButton.pGroup.pToolbar.isInputFocus = false;

    pButton.eButtonText = pButton.pGroup.pToolbar.tDoc.createElement('INPUT');
    pButton.eButtonText.setAttribute('type', 'text');
    pButton.eButtonText.setAttribute('style', 'position: absolute; left: 0px; top: 0px; z-index: 7; box-sizing: content-box !important; width: ' + (pButton.pAttribute.width - 26) + 'px; height: ' + (pButton.pAttribute.height - 16) + 'px; overflow: hidden; margin: 5px 3px; padding: 1px 2px 3px 2px; border: 1px solid #F5F5F5; background-color: #F5F5F5; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 11px; font-weight: normal; font-style: normal; color: #C1C1C1;');
    pButton.eButtonText.disabled = true;
    pButton.eButtonText.value = 'Size';

    pButton.eButton.appendChild(pButton.eButtonText);

    BEditor.domHandlers.addHandler(pButton.eButtonText, 'keypress', keyPressHandler);
    BEditor.domHandlers.addHandler(pButton.eButtonText, 'focus', onFocus);
    BEditor.domHandlers.addHandler(pButton.eButtonText, 'blur', onBlur);

    function onFocus ()
    {
      pButton.pAttribute.eButtonText.isFocus = true;
      pButton.pGroup.pToolbar.isInputFocus = true;
      validateValueTM = setInterval(validateValue, 30);

      pButton.pGroup.pToolbar.stopUnregEditorInstance();
      setTimeout(pButton.pGroup.pToolbar.stopUnregEditorInstance, 10);
    }

    function onBlur (e)
    {
      if (!e && window.event)
      {
        e = window.event;
      }

      if (e)
      {
        BEditor.domHandlers.stopEventBubbling(e);
      }

      if (!pButton.pAttribute.eButtonText.isFocus)
      {
        return false;
      }
      else
      {
        pButton.pAttribute.eButtonText.isFocus = false;
        pButton.pGroup.pToolbar.isInputFocus = false;
      }

      if (validateValueTM) clearInterval(validateValueTM);
      if (checkValueTM) clearInterval(checkValueTM);
      checkValue(true);
    }

    function validateValue ()
    {
      if (pButton.eButtonText.value !== prevValue)
      {
        prevValue = pButton.eButtonText.value;

        if (invalidCharacters.test(pButton.eButtonText.value))
        {
          pButton.eButtonText.value = pButton.eButtonText.value.replace(invalidCharacters, '');
        }
      }
    }

    function checkValue (isCustomSize)
    {
      const newSizeValue = parseInt(pButton.eButtonText.value);

      if (!isNaN(newSizeValue) && newSizeValue > 0 && pButton.pGroup.pToolbar.pEditor)
      {
        if (BEditor.browser.isIE && isCustomSize)
        {
          setTimeout(function () { pButton.pGroup.pToolbar.pEditor.setFontSize(pButton.pThis, newSizeValue); }, 10);
        }
        else
        {
          pButton.pGroup.pToolbar.pEditor.setFontSize(pButton.pThis, newSizeValue);
        }
      }
    }

    function keyPressHandler (e = window.event)
    {
      if (!e) return true;

      const key = (BEditor.browser.isGecko) ? e.which : e.keyCode,
            isSysKey = (BEditor.browser.isGecko) ? e.keyCode : false;

      if (key === 13)
      {
        pButton.eButtonText.blur();
        pButton.closeDropdown(true);
        BEditor.domHandlers.stopEvent(e);
      }
      else if (!isSysKey && !e.ctrlKey && '0123456789'.indexOf(String.fromCharCode(key).toLowerCase()) === -1)
      {
        BEditor.domHandlers.stopEvent(e);
      }
    }
  };


  this.preInitFontSizeDropdownButton = () =>
  {
    const fontSizes = pButton.pAttribute.parameters.fontSizes,
          fontSizeIds = pButton.pAttribute.parameters.fontSizeIds;

    let dropdownInnerHTML;

    pButton.pAttribute.parameters.dropdownItemsLenght = fontSizes.length;

    dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="width: 52px; padding: 5px 0; background-color: #F5F5F5;">'; //TODO:Dime fix width

    for (let i = 0; i < fontSizes.length; i++)
    {
      dropdownInnerHTML += '<div id="idItemsContainer_' + i + '" style="position: relative; width: 29px; overflow: hidden; padding: 5px 12px 5px 11px; font-family: Verdana, Arial, Helvetica, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; text-decoration: none;">';
      dropdownInnerHTML += '  <div style="width: 29px; overflow: hidden; white-space: nowrap;">';
      dropdownInnerHTML +=      fontSizes[i];
      dropdownInnerHTML += '  </div>';
      dropdownInnerHTML += '  <div ddtype="Item" ddvalue="' + fontSizeIds[i] + '" style="position: absolute; top: 0; left: 0; width: 50px; z-index: 7; background: transparent url(' + BEditor.utils.getZGif() + ') 0 0 repeat; cursor: ' + ((BEditor.browser.isIE) ? 'hand' : 'pointer') + ';"></div>';
      dropdownInnerHTML += '</div>';
    }

    dropdownInnerHTML += '</div>';

    pButton.pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pButton.pAttribute.id + '_Dropdown', pButton.pThis, pButton.pAttribute.parameters, dropdownInnerHTML);
    pButton.initDropdownComponents();
  };
}